

var map = "";
var map_trafficLayer = "";
import XInput from 'vux/src/components/x-input/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import urlSrc from '../common/UrlSource'
import StationInfo from '../components/StationInfo';
import ServiceAreaInfo from '../components/ServiceAreaInfo'
import PlanConstruction from '../components/PlanConstructionInfo';
import WeatherInfo from '../components/WeatherInfo';

export default {
name: "map-condition",
directives: {
TransferDom
},
components: {
XInput, Popup, WeatherInfo,
XSwitch, XHeader, Group, Cell,
StationInfo, Icon,
ServiceAreaInfo,
PlanConstruction
},
data() {
return {
showConfig: true,
layer: {
planConstruction: false
},
viewStatus: {
tollStation: true,
serviceArea: true,
trafficLayer: false,
planEvent: false,
trafficEvent: false,
weather: false
},
modalStatus: {
openModal: false,
tollStation: false,
serviceArea: false,
planConstruction: false,
weatherInfo: false,
},
markers: {
tollStation: [],
serviceArea: [],
weather: [],
planConstruction: []
},
mapData: {
tollStation: [],
serviceArea: [],
weather: [],
planConstruction: []
},
icon: {
rdCondition: false
},
thisMarker: {
name: "正在获取位置",
id: -1,
description: "距您 -- 公里",
type: 0 
},
location: {
lat: 0,
lng: 0
},
markerInfo: {}
}
},
methods: {
initMap: function () {
this.viewStatus = this.$store.state.viewStatus;
map_trafficLayer = new AMap.TileLayer.Traffic();
map = new AMap.Map('map', {
resizeEnable: true,
zoom: 9,
center: [103.845983, 36.059649]
});
this.changeTrafficLayer();
this.initLocation();
this.getStationData();
},
init: function () {
this.viewStatus = this.$store.state.viewStatus;
},
back: function () {
this.$store.commit("updateConfigLayer", false);
},
openModal: function () {
if (this.thisMarker.id != -1) {
this.modalStatus.tollStation = false;
this.modalStatus.serviceArea = false;
this.modalStatus.planConstruction = false;

if (this.thisMarker.type == 0) {
this.modalStatus.openModal = true;
this.modalStatus.tollStation = true;
this.getStationInfo();
} else if (this.thisMarker.type == 1) {

this.modalStatus.openModal = true;
this.modalStatus.serviceArea = true;
this.getServiceAreaInfo();
} else if (this.thisMarker.type == 2) {

this.modalStatus.weatherInfo = true;
} else if (this.thisMarker.type == 3) {

this.getPlanConstructionInfo();
}
}
},
closeModal: function () {
this.modalStatus.openModal = false;
},

getStationInfo: function () {
let url = urlSrc.dataServerUrl + "tollStation/" + this.thisMarker.id;
this.$http.get(url).then((res) => {
this.markerInfo = res.data;

}).catch((err) => {
});
},

getServiceAreaInfo: function () {
let url = urlSrc.dataServerUrl + "serviceArea/" + this.thisMarker.id;
this.$http.get(url).then((res) => {
this.markerInfo = res.data;
}).catch((err) => {
});
},

getPlanConstructionInfo: function () {
let url = urlSrc.dataServerUrl + "blockMessage/query?id=" + this.thisMarker.id;
this.$http.get(url).then((res) => {
this.markerInfo = res.data;
this.layer.planConstruction = true;
}).catch((err) => {
});
},

updateTrafficLayer: function () {
this.viewStatus.trafficLayer = !this.viewStatus.trafficLayer;
this.$store.commit("updateTrafficLayer", this.viewStatus.trafficLayer);
this.changeTrafficLayer();
},

changeTrafficLayer: function () {
this.icon.rdCondition = !this.icon.rdCondition;
if (this.$store.state.viewStatus.trafficLayer) {
map_trafficLayer.setMap(map);
} else {
map.remove(map_trafficLayer);
}
},

initLocation: function () {
const that = this;
var mapObj = new AMap.Map('iCenter');
mapObj.plugin('AMap.Geolocation', function () {
var geolocation = new AMap.Geolocation({
enableHighAccuracy: true,//是否使用高精度定位，默认:true
timeout: 10000,          //超过10秒后停止定位，默认：无穷大
maximumAge: 0,           //定位结果缓存0毫秒，默认：0
convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
showButton: true,        //显示定位按钮，默认：true
buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
zoomToAccuracy: true      
});
mapObj.addControl(geolocation);
geolocation.getCurrentPosition();
AMap.event.addListener(geolocation, 'complete', function (data) {
that.thisMarker.name = "获取成功";
that.location.lat = data.position.lat;
that.location.lng = data.position.lng;
let marker = new AMap.Marker({
icon: new AMap.Icon({
size: new AMap.Size(15, 18),//图标大小
imageSize: new AMap.Size(15, 18),
image: urlSrc.sourceUrl + "image/locationIcon.png"
}),
position: [data.position.lng, data.position.lat],
});
marker.setMap(map);
});//返回定位信息
AMap.event.addListener(geolocation, 'error', function () {
console.warn("定位失败")
});      //返回定位出错信息
});
},

searchFocus: function () {
},

getStationData: function () {
let url = urlSrc.dataServerUrl + "tollStations/all"
this.$http.get(url).then((res) => {
this.mapData.tollStation = res.data;
this.getServiceAreaData();
this.getPlanConstructionData();
}).catch((err) => {
});
},

getServiceAreaData: function () {
let url = urlSrc.dataServerUrl + "serviceAreas/all"
this.$http.get(url).then((res) => {
this.mapData.serviceArea = res.data;
this.getWeatherData();
}).catch((err) => {
});
},

getWeatherData: function () {
let url = urlSrc.dataServerUrl + "weather/all"
this.$http.get(url).then((res) => {
this.mapData.weather = res.data;
this.createView();
}).catch((err) => {
});
},

getPlanConstructionData: function () {
let url = urlSrc.dataServerUrl + "blockMessage/all"
this.$http.get(url).then((res) => {
this.mapData.planConstruction = res.data;
this.createView();
}).catch((err) => {
});
},

createStationView: function (data) {
const that = this;
data.forEach((v) => {
let marker = new AMap.Marker({
icon: new AMap.Icon({
size: new AMap.Size(30, 36),//图标大小
imageSize: new AMap.Size(30, 36),
image: urlSrc.sourceUrl + "image/tollStation.png"
}),
position: [v.longitude, v.latitude],
});
this.markers.tollStation.push(marker);

marker.on("click", function () {
that.$router.push({name: 'TollStation',params:{tollStation:v}})





});
marker.setLabel({
offset: new AMap.Pixel(-30, -25),
content: v.stationName
});
marker.setMap(map);
});


},

createServiceAreaView: function (data) {
const that = this;
data.forEach((v) => {
let marker = new AMap.Marker({
icon: new AMap.Icon({
size: new AMap.Size(30, 36),//图标大小
imageSize: new AMap.Size(30, 36),
image: urlSrc.sourceUrl + "image/serviceArea.png"
}),
position: [v.longitude, v.latitude],
});
this.markers.serviceArea.push(marker);

marker.on("click", function () {












that.$router.push({name: 'ServiceArea',params:{serviceArea:v}})
});
marker.setLabel({
offset: new AMap.Pixel(-30, -25),
content: v.servicesName
});
marker.setMap(map);

});


},

createWeatherView: function (data) {
const that = this;
data.forEach((v) => {
let marker = new AMap.Marker({
icon: new AMap.Icon({
size: new AMap.Size(40, 40),//图标大小
imageSize: new AMap.Size(40, 40),
image: urlSrc.sourceUrl + "image/weather/" + v.weatherPhenomenon + ".png"
}),
position: [v.longitude, v.latitude],
});

this.markers.weather.push(marker);

marker.on("click", function () {
that.thisMarker.name = v.sectionName;
that.thisMarker.description = v.drivingTips;
that.thisMarker.id = v.id;
that.thisMarker.type = 2;
that.markerInfo = v;
that.openModal();
});
marker.setMap(map);

});


},

createPlanConstructionView: function (data) {
const that = this;
data.forEach((v) => {
let marker = new AMap.Marker({
icon: new AMap.Icon({
size: new AMap.Size(40, 40),//图标大小
imageSize: new AMap.Size(40, 40),
image: urlSrc.sourceUrl + "image/map_shigong.png"
}),
position: [v.longitude, v.latitude],
});
this.markers.planConstruction.push(marker);

marker.on("click", function () {
that.thisMarker.name = "计划施工";
that.thisMarker.description = v.reportout;
that.thisMarker.id = v.eventid;
that.thisMarker.type = 3;
that.openModal();
});

marker.setMap(map);
});


},

redirectPage: function () {
this.$store.commit("updateConfigLayer", true);
},

getDistance: function (desLon, desLat) {
let startLonLat = this.location.lng + "," + this.location.lat;
let endLonLat = desLon + "," + desLat;
let queryUrl = "http://restapi.amap.com/v3/distance?key=2e4a8fb4fb0a9aa19f5f8df10088ed64&" +
"origins=" + startLonLat + "&destination=" + endLonLat; 
this.$http.get(queryUrl).then((res) => {
let distance = res.data.results[0].distance * 0.001;
this.thisMarker.description = "距您:" + distance.toFixed(2) + "公里";
}).catch((err) => {

})
},

createView: function () {
if (this.viewStatus.tollStation) {
this.createStationView(this.mapData.tollStation);
} else {
map.remove(this.markers.tollStation);
}
if (this.viewStatus.serviceArea) {
this.createServiceAreaView(this.mapData.serviceArea);
} else {
map.remove(this.markers.serviceArea);
}
if (this.viewStatus.weather) {
this.createWeatherView(this.mapData.weather);
} else {
map.remove(this.markers.weather);
}
if (this.viewStatus.planEvent) {
this.createPlanConstructionView(this.mapData.planConstruction);
} else {
map.remove(this.markers.planConstruction);
}
},
toCityCondition:function () {
this.$router.push({name: 'MapCityCondition'})
}

},
mounted() {
this.$nextTick(() => {
this.showConfig = this.$store.state.layer;
this.initMap();
})
}
}



// WEBPACK FOOTER //
// ./src/container/MapCondition.vue